module.exports = __webpack_public_path__ + "static/2-59fb832139835cbaac3f569589339de3.jpeg";